import { label, labelSecondary, valueSecondary } from 'styles'

import { makeStyles } from '@mui/styles'
import type { Theme } from '@mui/system'

export default makeStyles((theme: Theme) => ({
  cell: {
    height: '100%',
    padding: '0.8rem',
  },
  description: {
    backgroundColor: labelSecondary,
    borderBottom: `1px solid ${label}`,
    fontSize: '1.2rem',
    fontWeight: '700',
    padding: '0.8rem',
    textAlign: 'center',
  },
  header: {
    backgroundColor: labelSecondary,
    fontWeight: '700',
    padding: '0.8rem',
    textAlign: 'center',
  },
  icon: {
    alignSelf: 'center',
    color: label,
    display: 'flex',
    justifyItems: 'center',
    textAlign: 'center',

    '&&': {
      flexDirection: 'column',
    },
  },
  marginLeft: {
    marginLeft: '0.5rem',
  },
  missingData: {
    alignItems: 'center',
    color: valueSecondary,
    display: 'flex',
    fontWeight: '600',
    justifyContent: 'center',
    padding: '0.8rem',
  },
  percent: {
    display: 'inline-block',
    '& .info_percent-difference': {
      color: label,
      fontWeight: '400' as 'normal',
    },
    fontSize: '1rem',
  },
  returnsValue: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(3),
    },
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(6),
    },
  },
  revenueValue: {
    height: '100%',
  },
  value: {
    alignSelf: 'center',
    fontSize: '1rem',
    fontWeight: '600',
    textAlign: 'right',
  },
}))
